module.exports = __webpack_public_path__ + "static/media/KW12_AS2.cb6342a6.JPG";